module.exports = __webpack_public_path__ + "static/media/result_leclerc22.6d3c4c44.jpg";